export const depense = {
  title_create: "Créer un dépense",
  name: "Dépenses",

  toast_success: "Dépense enregistrée avec succès !",
  toast_error: "Erreur lors de l'enregistrement !",
  form: {
    supplier: "Fournisseur",
    select_supplier: "Sélectionnez un fournisseur",
    date: "Date",
    dateCreation: "Date de création",
    invoice_number: "Numéro de facture",
    description: "Description",
    submit: "Enregistrer la dépense",
    justificatif: "Justificatif",
    error_required: "Ce champ est obligatoire",
    title: "Modifier dépense",
    update_submit: "Confirmer",
    invoice_input_type: "Type de saisie de facture",
    select_existing_invoice: "Sélectionner une facture existante",
    import_pdf: "Importer un PDF",
    import_image: "Importer une image",
    select_pdf_file: "Sélectionner un fichier PDF",
    select_image_file: "Sélectionner un fichier image",
    image_upload_coming_soon: "Import d'image bientôt disponible",
    pdf_preview: "Aperçu PDF",
    image_preview: "Aperçu Image",
    extracted_data: "Données extraites",
    error_pdf_only: "Seuls les fichiers PDF sont acceptés",
    error_processing_pdf: "Erreur lors du traitement du PDF",
    error_loading_pdf: "Erreur lors du chargement du PDF",
    pdf_processed_success: "PDF traité avec succès",
  },
  table: {
    title: "Produits achetés",
    name: "Nom",
    quantity: "Quantité",
    price_ht: "Prix HT",
    tva: "TVA (%)",
    description: "Description",
    total: "Total (TTC)",
    action: "Action",
    add_product: "Ajouter un produit",
    invoice_number: "N° facture",
    createdBy: "Créé par",
    remise: "Remise",
  },
  total: {
    ht: "Total HT",
    tva: "Total TVA",
    ttc: "Total TTC",
  },
  header_title: "Dépenses",
};
